import { MenuItemLocationProps } from 'types/MenuItemLocationProps';

export function verifyForm(dataForm: MenuItemLocationProps, handleNotify: any) {
	if (dataForm.name === '') {
		handleNotify('Preencha o nome do item', 'error');
		return false;
	}

	return true;
}
